<span
  *ngIf="!isLoadingStats && !isLoadingStatsErrorOccured"
  [countUp]="number"
  class="number"
  >0</span
>
<div
  *ngIf="isLoadingStats && !isLoadingStatsErrorOccured"
  class="loading-users-stats"
></div>
<i class="error-stats" *ngIf="!isLoadingStats && isLoadingStatsErrorOccured"
  >Something went wrong.</i
>
